export default __webpack_public_path__ + "static/media/flag-pl.0120a09f.svg";